import Vue from 'vue'
import VueRouter from 'vue-router'

import Index from "@/views/new/Index.vue";
import About from "@/views/new/About.vue";
import Solution1 from "@/views/new/solutions/Solution1.vue";
import Solution2 from "@/views/new/solutions/Solution2.vue";
import Solution3 from "@/views/new/solutions/Solution3.vue";

import DataService1 from "@/views/new/products/data-service1.vue";
import DataService2 from "@/views/new/products/data-service2.vue";
import DataService3 from "@/views/new/products/data-service3.vue";

import DeepSeek from "@/views/new/products/deepseek.vue";
import Agent from "@/views/new/products/agent.vue";
import PC from "@/views/new/products/pc.vue";
import GenAI from "@/views/new/products/genai.vue";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Index',
        component: Index,
        meta: {
            title: '首頁 | BOATWATER HK',
        },
    },
    {
        path: '/agent',
        name: 'Agent',
        component: Agent,
        meta: {
            title: '企業級Agent中台 | BOATWATER HK',
        },
    },
    {
        path: '/deep-seek',
        name: 'DeepSeek',
        component: DeepSeek,
        meta: {
            title: 'DeepSeek企業版 | BOATWATER HK',
        },
    },
    {
        path: '/pc',
        name: 'PC',
        component: PC,
        meta: {
            title: 'PC本地部署大模型 | BOATWATER HK',
        },
    },
    {
        path: '/gen-ai',
        name: 'GenAI',
        component: GenAI,
        meta: {
            title: '企業級一站式GenAI平台 | BOATWATER HK',
        },
    },
    {
        path: '/solution1',
        name: 'Solution1',
        component: Solution1,
        meta: {
            title: '汽车业服务方案 | BOATWATER HK',
        },
    },
    {
        path: '/solution2',
        name: 'Solution2',
        component: Solution2,
        meta: {
            title: '金融业综合服务方案 | BOATWATER HK',
        },
    },
    {
        path: '/solution3',
        name: 'Solution3',
        component: Solution3,
        meta: {
            title: '零售业服务方案 | BOATWATER HK',
        },
    },
    {
        path: '/about',
        name: 'About',
        component: About,
        meta: {
            title: '关于我们 | BOATWATER HK',
        },
    },
    {
        path: '/data-service1',
        name: 'DataService1',
        component: DataService1,
        meta: {
            title: '數據安全管控平台 | BOATWATER HK',
        },
    },
    {
        path: '/data-service2',
        name: 'DataService2',
        component: DataService2,
        meta: {
            title: '數據治理諮詢與實施服務 | BOATWATER HK',
        },
    },
    {
        path: '/data-service3',
        name: 'DataService3',
        component: DataService3,
        meta: {
            title: '數字化應用開發 | BOATWATER HK',
        },
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    next();
    window.scrollTo(0, 0)
});

export default router
